import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("38b5f9f89c", "._55e7ea149e11edaf__wrapper{box-sizing:border-box}");
}
export default {"wrapper":"_55e7ea149e11edaf__wrapper"};
